<script lang="ts" setup>
	const { CACVerified } = reactor(useUser())
	const { toggleCACModal } = useUser()
</script>
<template>
	<div>
		<ui-alert v-if="!CACVerified" variant="error" class="shadow-[0px_0px_8px_0px_rgba(131,131,131,0.08)]">
			<div class="flex w-full items-center justify-between">
				<p>Submit your CAC for business verification</p>
			</div>

			<template #prefix>
				<ui-button text="Submit CAC" variants="one" class="sm:px-[43px] sm:py-[14px]" @click="toggleCACModal" />
			</template>
		</ui-alert>
	</div>
</template>
